/* Puritas — AJAX cart + slide-out drawer (Phase A)
   Self-contained vanilla controller. Drives Shopify's AJAX Cart API
   (/cart/add.js, /cart/change.js, /cart.js) and renders the drawer.
   No ES-module dependency — matches the Puritas self-contained pattern. */
(function () {
  'use strict';

  var cfg = window.PuritasCart || {};
  var THRESHOLD = typeof cfg.freeShipThreshold === 'number' ? cfg.freeShipThreshold : 10000;
  var UPSELL = Array.isArray(cfg.upsell) ? cfg.upsell : [];

  var drawer, overlay, shipWrap, body, foot, countNodes, lastFocus;

  /* ---------- helpers ---------- */
  function money(cents) {
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + v.join('.');
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Shopify Cart API ---------- */
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addItem(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw e; }); }
      return r.json();
    });
  }
  function changeItem(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- rendering ---------- */
  function updateCounts(cart) {
    (countNodes || []).forEach(function (n) { n.textContent = cart.item_count; });
    document.dispatchEvent(new CustomEvent('puritas:cart:updated', { detail: cart }));
  }

  function renderShip(cart) {
    var remaining = THRESHOLD - cart.total_price;
    var pct = Math.max(0, Math.min(100, (cart.total_price / THRESHOLD) * 100));
    var msg;
    if (cart.item_count === 0) { msg = 'Free shipping over ' + money(THRESHOLD); }
    else if (remaining > 0) { msg = '<strong>' + money(remaining) + '</strong> away from free shipping'; }
    else { msg = "You've unlocked <strong>free shipping</strong>"; }
    return '<div class="cart-ship"><div class="cart-ship__msg">' + msg +
      '</div><div class="cart-ship__bar"><div class="cart-ship__fill" style="width:' + pct + '%"></div></div></div>';
  }

  function renderLine(item, i) {
    var line = i + 1;
    var img = item.image
      ? '<div class="cart-line__img"><img src="' + esc(item.image) + '" alt="" loading="lazy"></div>'
      : '<div class="cart-line__img"></div>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-line__variant">' + esc(item.variant_title) + '</div>' : '';
    var plan = item.selling_plan_allocation
      ? '<div class="cart-line__plan">Research plan · every 28 days</div>' : '';
    return '<div class="cart-line" data-line="' + line + '">' +
      img +
      '<div><div class="cart-line__name">' + esc(item.product_title) + '</div>' + variant + plan +
        '<div class="cart-line__qty" data-line="' + line + '">' +
          '<button type="button" data-act="dec" aria-label="Decrease quantity">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-act="inc" aria-label="Increase quantity">+</button>' +
        '</div>' +
      '</div>' +
      '<div class="cart-line__right">' +
        '<div class="cart-line__price">' + money(item.final_line_price) + '</div>' +
        '<button type="button" class="cart-line__remove" data-line="' + line + '">Remove</button>' +
      '</div>' +
    '</div>';
  }

  function renderUpsell(cart) {
    if (!UPSELL.length) { return ''; }
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var avail = UPSELL.filter(function (p) { return !inCart[p.product_id]; }).slice(0, 2);
    if (!avail.length) { return ''; }
    var rows = avail.map(function (p) {
      var img = p.image
        ? '<div class="cart-upsell__img"><img src="' + esc(p.image) + '" alt="" loading="lazy"></div>'
        : '<div class="cart-upsell__img"></div>';
      return '<div class="cart-upsell__item">' + img +
        '<div><div class="cart-upsell__name">' + esc(p.title) + '</div>' +
        '<div class="cart-upsell__price">' + money(p.price) + '</div></div>' +
        '<button type="button" class="cart-upsell__add" data-add-id="' + esc(p.variant_id) +
        '" aria-label="Add ' + esc(p.title) + '">+</button></div>';
    }).join('');
    return '<div class="cart-upsell"><div class="cart-upsell__label">Add to your research</div>' + rows + '</div>';
  }

  function renderFoot(cart) {
    if (cart.item_count === 0) { return ''; }
    var hasPlan = cart.items.some(function (it) { return it.selling_plan_allocation; });
    var disclaimer = hasPlan
      ? '<p class="cart-foot__disclaimer">Items on a research plan rebill and ship every 28 days. Pause or cancel anytime.</p>'
      : '';
    return '<div class="cart-foot__row"><span class="lbl">Subtotal</span>' +
      '<span class="cart-foot__total">' + money(cart.total_price) + '</span></div>' +
      disclaimer +
      '<a class="btn primary cart-foot__checkout" href="/checkout">Proceed to checkout</a>';
  }

  function render(cart) {
    shipWrap.innerHTML = renderShip(cart);
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty">Your cart is empty</div>';
    } else {
      body.innerHTML = cart.items.map(renderLine).join('') + renderUpsell(cart);
    }
    foot.innerHTML = renderFoot(cart);
    updateCounts(cart);
    return cart;
  }

  /* ---------- open / close + focus trap ---------- */
  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var c = drawer.querySelector('.cart-drawer__close');
    if (c) { c.focus(); }
    document.addEventListener('keydown', onKey);
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') { return; }
    var f = drawer.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) { return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function refresh(openAfter) {
    return getCart().then(function (cart) { render(cart); if (openAfter) { open(); } return cart; });
  }

  /* ---------- add-to-cart form interception (U1) ---------- */
  function onSubmit(e) {
    var form = e.target.closest && e.target.closest('form.puritas-add-form, form[action$="/cart/add"]');
    if (!form) { return; }
    if (!form.querySelector('[name="id"]')) { return; }
    e.preventDefault();
    var fd = new FormData(form);
    var payload = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
    var sp = fd.get('selling_plan');
    if (sp) { payload.selling_plan = sp; }
    var btn = form.querySelector('[name="add"], [type="submit"]');
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    clearError(form);
    addItem(payload)
      .then(function () { return refresh(true); })
      .catch(function (err) { showError(form, (err && err.description) || 'Could not add to cart.'); })
      .then(function () { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); } });
  }
  function showError(form, msg) {
    clearError(form);
    var d = document.createElement('div');
    d.className = 'cart-add-error';
    d.textContent = msg;
    form.appendChild(d);
  }
  function clearError(form) {
    var ex = form.querySelector('.cart-add-error');
    if (ex) { ex.parentNode.removeChild(ex); }
  }

  /* ---------- drawer body interactions ---------- */
  function onBodyClick(e) {
    var addBtn = e.target.closest('[data-add-id]');
    if (addBtn) {
      addBtn.disabled = true;
      addItem({ id: addBtn.getAttribute('data-add-id'), quantity: 1 })
        .then(function () { return refresh(false); })
        .catch(function () { addBtn.disabled = false; });
      return;
    }
    var qBtn = e.target.closest('.cart-line__qty button');
    if (qBtn) {
      var wrap = qBtn.closest('.cart-line__qty');
      var line = parseInt(wrap.getAttribute('data-line'), 10);
      var cur = parseInt(wrap.querySelector('span').textContent, 10);
      var next = qBtn.getAttribute('data-act') === 'inc' ? cur + 1 : cur - 1;
      wrap.classList.add('is-busy');
      changeItem(line, next < 0 ? 0 : next).then(render);
      return;
    }
    var rm = e.target.closest('.cart-line__remove');
    if (rm) {
      changeItem(parseInt(rm.getAttribute('data-line'), 10), 0).then(render);
    }
  }

  /* ---------- init ---------- */
  function init() {
    drawer = document.getElementById('cart-drawer');
    if (!drawer) { return; }
    overlay = drawer.querySelector('.cart-drawer__overlay');
    shipWrap = drawer.querySelector('#cart-drawer-ship');
    body = drawer.querySelector('#cart-drawer-body');
    foot = drawer.querySelector('#cart-drawer-foot');
    countNodes = [].slice.call(document.querySelectorAll('.js-cart-count'));

    drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    body.addEventListener('click', onBodyClick);
    document.addEventListener('submit', onSubmit);

    [].slice.call(document.querySelectorAll('.header-cart, [data-cart-open]')).forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
    });

    getCart().then(render).catch(function () {});
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
